import { useNavigate } from '@tanstack/react-router';
import {
  createChatNavigation,
  useBaseOwnerId,
  type ChatNavigationOptions
} from '@rhino-project/core/hooks';

export const useChatNavigation = (options: ChatNavigationOptions) => {
  const ownerId = useBaseOwnerId();
  const navigate = useNavigate();
  return createChatNavigation({
    ...options,
    ownerId,
    // CRUD paths come from registered model metadata at runtime, just as they
    // do for Rhino's create/show actions, rather than the host's route union.
    navigate: (destination) =>
      navigate(destination as Parameters<typeof navigate>[0])
  });
};
